/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { Divider, CircularProgress, Card } from "@material-ui/core";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import R406InventoryItemStockSummaryFilter from "./chunks/R406InventoryItemStockSummaryFilter";
import DxGridTable from "../../../components/DxGridTable/DxGridTable";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 110,
  },
});

class F400InventoryItemForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      showTableFilter: false,

      searchText: "",
      searchTextError: "",

      fromDate: null,
      fromDateError: "",

      toDate: null,
      toDateError: "",

      categoriesData: [],
      categoriesDataLoading: false,
      categoryId: "",
      categoryIdError: "",

      itemsList: [],

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",

      isLoginMenu: false,
      isReload: true,
    };
  }

  componentDidMount() {
    this.getData(
      "GET",
      "/inventory/C406CommonInventoryItemsCategoriesView",
      null,
      "categoriesData",
      "categoriesDataLoading"
    );
    this.getData(
      "POST",
      "/inventory/C406CommonInventoryItemsView?categoryId=0",
      null,
      "itemsList",
      "isLoading"
    );
  }

  onSearchButtonClick = () => {
    const myCategoryId =
      this.state.categoryId && this.state.categoryId > 0
        ? this.state.categoryId
        : 0;
    this.getData(
      "POST",
      `/inventory/C406CommonInventoryItemsView?categoryId=${myCategoryId}&fromDate=${this.state.fromDate}&toDate=${this.state.toDate}`,
      null,
      "itemsList",
      "isLoading"
    );
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    const errName = `${name}Error`;
    let errMsg = "";
    this.setState({
      [name]: value || "",
      [errName]: errMsg,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  getData = async (
    method = "",
    endpoint = "",
    data = null,
    stateName = "",
    loadingStateName = ""
  ) => {
    let resData = [];
    this.setState({
      [loadingStateName]: true,
    });
    const res = await HttpRequest(
      method,
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}${endpoint}`,
      data,
      "authorizeJson"
    );
    if (res.isSuccess) {
      resData = res.data || [];
    } else {
      if (res.statusCode === 401) {
        this.setState({
          isLoginMenu: true,
        });
      }
    }
    this.setState({
      [stateName]: resData,
      [loadingStateName]: false,
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({
      isOpenSnackbar: isOpen,
      snackbarMessage: message,
      snackbarSeverity: severity,
    });
  };

  render() {
    const { classes } = this.props;
    const tableColumnExtensions = [
      // { columnName: "id", width: 100 },
    ];
    const columns = [
      { name: "lastPurchaseDateLabel", title: "Purchase Date" },
      { name: "categoryLabel", title: "Category" },
      { name: "label", title: "Material Name" },
      { name: "totalQuantityLabel", title: "Total Qty" },
      { name: "issuanceQuantityLabel", title: "Issuance Qty" },
      { name: "availableQuantityLabel", title: "Available Qty" },
    ];
    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />
        <NavBar isAuthorize />
        <div className={classes.root}>
          <div className={classes.topMargin}>
            <R406InventoryItemStockSummaryFilter
              state={this.state}
              l
              handleChange={(e) => this.handleChange(e)}
              handleToggleTableFilter={() => this.handleToggleTableFilter()}
              onSearchButtonClick={() => this.onSearchButtonClick()}
            />
          </div>
          <Divider style={{ marginTop: 10, marginBottom: 30 }} />
          <Card className={classes.topMargin}>
            {!this.state.isLoading ? (
              <DxGridTable
                data={this.state.itemsList}
                columns={columns}
                showFilter={this.state.showTableFilter}
                isLoading={this.state.isLoading}
                tableColumnExtensions={tableColumnExtensions}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 50,
                  width: "100%",
                  overflow: "hidden",
                  height: "90px",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </Card>
        </div>
      </Fragment>
    );
  }
}

F400InventoryItemForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles)(F400InventoryItemForm);
